<template>
  <div v-if="providers.length > 1">
    <b-form-group label="Authorization Provider">
      <b-dropdown :text="selectedProvider.displayName">
        <b-dropdown-item
          v-for="(provider, index) in providers"
          :key="index"
          @click="selectProvider(provider)"
        >
          {{ provider.displayName }}
        </b-dropdown-item>
      </b-dropdown>
    </b-form-group>
  </div>
</template>

<script>
// Default to last user selection.
let lastProvider = localStorage.getItem('lbs-auth-provider');
// If last user selection not present (first time access) then default to Windows auth.
if (!lastProvider) {
  lastProvider = 'Windows';
}

export default {
  name: 'ProviderSelector',
  props: {
    providers: {
      type: Array,
      required: true
    },
    value: {
      type: Object,
      default () { return {}; }
    }
  },
  data () {
    return {
      selectedProvider: {}
    };
  },
  methods: {
    selectProvider (provider) {
      if (this.selectedProvider !== provider) {
        this.selectedProvider = provider;
        this.$emit('input', this.selectedProvider);
      }
    }
  },
  watch: {
    selectedProvider () {
      localStorage.setItem('lbs-auth-provider', this.selectedProvider.authenticationScheme);
    }
  },
  mounted () {
    const selectedProvider = this.providers.find(p => p.authenticationScheme === lastProvider);
    // If the last selected provider was not found just default to the first available.
    this.selectProvider(selectedProvider || this.providers[0]);
  }
};
</script>

<style scoped>
</style>
